"use client";
import { Button } from "@website/ui/button";
import { Modal } from "@website/ui/modal";
import { useRedirectModal } from "@website/widget/redirect-modal/hooks";

const RedirectModal = () => {
  const { isOpen, redirectUrl } = useRedirectModal();

  return (
    <Modal open={isOpen}>
      <div className="flex flex-col gap-6 lg:w-[448px]">
        <h6 className="text-headline-6 text-on-surface-high-emphasis">
          ورود به حساب کاربری
        </h6>
        <div className="text-on-surface-high-emphasis text-body-2">
          برای ادامه خرید به حساب کاربری خود وارد شوید.
        </div>
        <div className="w-full pt-4">
          <a href={redirectUrl}>
            <Button
              variant="contained"
              size="medium"
              color="secondary"
              fullWidth={true}
            >
              تایید و ادامه
            </Button>
          </a>
        </div>
      </div>
    </Modal>
  );
};
export default RedirectModal;
